<template>
    <div>
        <main-header
            iconLeftBtn="el-icon-back"
            @onClickLeftBtn="backToChangePhone"
            v-if="!isErrorSystem"
        >
            <data-form
                :title="title"
                :sub_title="
                    `${$t('otp.input-change-phone-otp', {
                        number: phoneNumber,
                        ref: refCode,
                    })}`
                "
                show_logo
                :logo_src="require('@/assets/img/icon-change-phone.jpg')"
            >
                <div class="flex crm-otp-entry">
                    <div
                        :class="
                            `otp-input-box ${
                                isError ? 'otp-input-box_error' : ''
                            }`
                        "
                        v-for="dot in [0, 1, 2, 3, 4, 5]"
                        :key="'dot-' + dot"
                    >
                        <div
                            class="dot"
                            v-if="OTPValidateForm.numberOTP.length >= dot + 1"
                        >
                            {{ OTPValidateForm.numberOTP[dot] }}
                        </div>
                        <div
                            class="crm-otp-cursor"
                            v-if="OTPValidateForm.numberOTP.length == dot"
                        >
                            |
                        </div>
                    </div>
                    <input
                        id="hide-input"
                        v-model="OTPValidateForm.numberOTP"
                        type="text"
                        inputmode="numeric"
                        pattern="[0-9]*"
                        @input="authOTPCode()"
                        @keypress="onlyNumber"
                        @focus="trackAuthentication(19)"
                        autocomplete="off"
                        maxlength="6"
                        ref="otp_input"
                    />
                </div>
                <el-row>
                    <el-col v-if="isError && !isCountDown" class="error-msg">
                        <p>
                            {{ isError }} <br />
                            <span>{{ $t('otp.not-received-otp') }}</span>
                            <a
                                class="crm-resend-code"
                                type="primary"
                                @click="handleResendOTP"
                                >{{ $t('otp.send-again') }}</a
                            >
                        </p>
                    </el-col>
                    <el-col v-else-if="isError" class="error-msg">
                        <p>
                            {{ isError }} <br />
                            <a type="primary"
                                >{{ $t('otp.send-again-in') }}
                                {{ countdown }}</a
                            >
                        </p>
                    </el-col>
                    <el-col v-else-if="!isCountDown" class="crm-resend-code">
                        <span class="crm-unsend-code">{{
                            $t('otp.not-received-otp')
                        }}</span>
                        <a type="primary" @click="handleResendOTP">{{
                            $t('otp.send-again')
                        }}</a>
                    </el-col>
                    <el-col v-else class="crm-resend-code crm-unsend-code">
                        <a type="primary"
                            >{{ $t('otp.send-again-in') }} {{ countdown }}</a
                        >
                    </el-col>
                </el-row>
                <el-divider class="mt-4 mb-2">{{ $t('login.or') }}</el-divider>
                <el-row>
                    <el-col style="text-align: center;">
                        <el-button
                            class="btn-change-phone"
                            @click="backToChangePhone"
                        >
                            <span>
                                <svgRefresh />{{ $t('otp.change-phone') }}
                            </span>
                        </el-button>
                    </el-col>
                </el-row>
            </data-form>
        </main-header>
        <main-header v-else>
            <div class="card-system-error">
                <div class="d-flex justify-center align-center check-phone">
                    <img
                        :src="require('@/assets/svg/warning.svg?inline')"
                        width="120"
                        alt=""
                    />
                </div>
                <div class="dialog-topic">
                    {{ $t('change-phone.system-crash') }}
                </div>
                <div class="dialog-description" v-html="$t('change-phone.error-change')" />
                <div class="dialog-button">
                    <el-button
                        class="btn-change-phone"
                        @click="backToChangePhone"
                    >
                        <span>
                            <svgRefreshBack class="mr-1" />{{
                                $t('change-phone.try-again')
                            }}
                        </span>
                    </el-button>
                </div>
            </div>
        </main-header>
        <crm-dialog :visible="isChanged" width="70%">
            <div class="d-flex justify-center align-center check-phone">
                <img
                    :src="require('@/assets/svg/check.svg?inline')"
                    width="120"
                    alt=""
                />
            </div>
            <div
                class="dialog-topic font1-5rem"
                v-html="$t('change-phone.change-successfully')"
            />
            <div
                class="dialog-description font1-25rem"
                v-html="
                    $t('change-phone.changed', {
                        phoneNumber: resendParams.phoneNumberFormatted,
                    })
                "
            />
        </crm-dialog>
        <WaterMark />
    </div>
</template>

<script>
const moment = require('moment')
import mixins from '../../helper/mixins'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import DataForm from '@/components/DataForm'
import MainHeader from '@/components/MainHeader.vue'
const svgRefresh = () => import('@/assets/svg/refresh.svg')
const svgRefreshBack = () => import('@/assets/svg/refresh-1.svg')
import GATracking from '@/helper/GATrackingMixins'
import CrmDialog from '@/components/Dialog.vue'
import WaterMark from '@/components/WaterMark.vue'
import TokenStorage from '@/store/storage/token.storage'

export default {
    components: {
        DataForm,
        MainHeader,
        svgRefresh,
        svgRefreshBack,
        CrmDialog,
        WaterMark,
    },
    mixins: [mixins, GATracking],
    data() {
        return {
            title: this.$t('otp.input-title'),
            numberOTP: null,
            OTPValidateForm: { numberOTP: '', refCode: '' },
            isCountDown: false,
            countdown: '...',
            timerOtp: false,
            isLoading: false,
            isError: false,
            isChanged: false,
            haveBranch: false,
            isErrorSystem: false,
            fullscreenLoading: false,
            resendParams: {
                phoneNumber: '',
                phoneCountryCode: '',
                phoneNumberFormatted: '',
                refCode: '',
            },
        }
    },
    computed: {
        ...mapGetters({
            restaurantUUID: 'restaurant/restaurantUUID',
            branchInfo: 'branch/branchInfo',
            authDialog: 'auth/authDialog',
            otpTime: 'auth/otpTime',
            branchUUID: 'branch/branchUUID',
        }),
        phoneNumber() {
            if (this.$route.query.phoneNumberFormatted) {
                return this.$route.query.phoneNumberFormatted
            }
            return ''
        },
        refCode() {
            if (this.$route.query.refCode) {
                return this.$route.query.refCode
            }
            return ''
        },
    },
    async mounted() {
        const {
            phoneNumber,
            phoneCountryCode,
            phoneNumberFormatted,
            refCode,
        } = this.$route.query
        if (
            phoneNumber &&
            phoneCountryCode &&
            phoneNumberFormatted &&
            refCode
        ) {
            this.resendParams.phoneCountryCode = phoneCountryCode
            this.resendParams.phoneNumber = phoneNumber
            this.resendParams.phoneNumberFormatted = phoneNumberFormatted
            this.resendParams.refCode = refCode
        }

        this.$refs.otp_input.focus()
        this.setCountDown()
    },
    methods: {
        ...mapActions({
            login: 'auth/login',
            sendVerifyHandler: 'user/sendVerifyHandler',
            changePhoneHandler: 'user/changePhoneHandler',
        }),
        ...mapMutations({
            setOtpTime: 'auth/SET_OTP_TIME',
            clearOtpTime: 'auth/CLEAR_OTP_TIME',
        }),
        backToChangePhone() {
            this.clearOtpTime()
            this.$router.push({
                name: 'ChangePhone',
            })
        },
        async authOTPCode() {
            this.isError = false
            if (this.OTPValidateForm.numberOTP.length == 6) {
                this.isLoading = this.$loading({
                    lock: true,
                })

                const {
                    phoneNumber,
                    phoneCountryCode,
                    refCode,
                } = this.resendParams

                await this.changePhoneHandler({
                    phoneNumber,
                    phoneCountryCode,
                    refCode,
                    restaurantUUID: this.restaurantUUID,
                    otp: this.OTPValidateForm.numberOTP.toString(),
                    recaptchaToken: TokenStorage.recaptchaToken,
                })
                    .then(() => {
                        this.isChanged = true
                        setTimeout(() => {
                            this.$router.push({
                                name: 'Profile',
                            })
                        }, 3000)
                    })
                    .catch(error => {
                        this.OTPValidateForm.numberOTP = ''
                        if (error && error.errorSystem) {
                            this.isErrorSystem = true
                            return
                        }
                        this.isError = error
                    })
                    .finally(() => {
                        this.isLoading.close()
                    })
            }
        },
        async handleResendOTP() {
            this.isError = false
            this.clearOtpTime()
            this.setCountDown()
            this.isLoading = true
            const {
                phoneNumber,
                phoneCountryCode,
                phoneNumberFormatted,
            } = this.resendParams

            await this.sendVerifyHandler({
                recaptchaToken: TokenStorage.recaptchaToken,
                restaurantUUID: this.restaurantUUID,
                phoneNumber,
                phoneCountryCode,
            })
                .then(response => {
                    const { refCode } = response
                    this.$router.replace({
                        query: {
                            phoneNumber,
                            phoneCountryCode,
                            refCode,
                            phoneNumberFormatted,
                        },
                    })
                })
                .catch(error => {
                    this.OTPValidateForm.numberOTP = ''
                    this.isError = error
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
        setCountDown() {
            this.isCountDown = true
            if (this.timerOtp) clearInterval(this.timerOtp)

            const nowTime = new Date().getTime()
            const duration = 60 * 2000 // 2 min
            let endTime = nowTime + duration // in timestamp
            if (this.otpTime && nowTime > this.otpTime) {
                endTime = new Date(this.otpTime + duration)
            } else {
                this.setOtpTime(nowTime)
            }

            this.countdown = moment(
                new Date(endTime - new Date().getTime()),
            ).format('mm:ss')
            this.timerOtp = setInterval(() => {
                this.countdown = moment(
                    new Date(endTime - new Date().getTime()),
                ).format('mm:ss')
            }, 1000) // 1 sec

            setTimeout(() => {
                this.isCountDown = false
                clearInterval(this.timerOtp)
                this.clearOtpTime()
            }, endTime - new Date().getTime())
        },
        redirectFunction() {
            this.fullscreenLoading = true
            this.login()
        },
    },
}
</script>

<style scoped>
.d-flex-center-middle {
    display: flex;
    align-items: center;
    justify-content: center;
}

@keyframes blink {
    from,
    to {
        color: transparent;
    }
    50% {
        color: #000000;
    }
}

@-webkit-keyframes blink {
    from,
    to {
        color: transparent;
    }
    50% {
        color: #000000;
    }
}

.white-box {
    height: 70vh;
}

.otp-input-box {
    max-width: 44px;
    width: 44px;
    width: -webkit-fill-available;
    height: 50px;
    position: relative;
    background: #f9f9f9;
    border-radius: 8px;
    margin-left: 8px;
    border: 1px solid #cfd0d1;
}
.otp-input-box_error {
    border-color: var(--error);
}

.back-input-phone {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    text-decoration-line: underline;
    color: #28b7ff;
    text-decoration-thickness: 0.5px;
    text-underline-offset: 2px;
    margin-left: 5px;
    width: 100px;
}
.btn-change-phone {
    margin-top: 24px;
    width: 100%;
    color: #28b7ff;
    border: 1px solid #28b7ff;
    border-radius: 8px;
    padding: 8px 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
}
.btn-change-phone span {
    display: flex;
    align-items: center;
}
.mt-15-flex-center {
    display: flex;
    justify-content: center;
    margin-top: 15px;
}

.dot {
    display: inline-block;
    position: absolute;
    top: 20%;
    left: 40%;
    font-size: 24px;
}

.crm-otp-entry {
    width: 100%;
    margin: auto;
    margin-top: 32px;
    margin-bottom: 0;
    justify-content: center;
}

.crm-otp-cursor {
    top: 10%;
    position: relative;
    margin: 0;
    font-weight: 200;
    font-size: 30px;
    color: #000000;
    display: block;
    text-align: center;
    -webkit-animation: 1s blink step-end infinite;
    -moz-animation: 1s blink step-end infinite;
    -ms-animation: 1s blink step-end infinite;
    -o-animation: 1s blink step-end infinite;
    animation: 1s blink step-end infinite;
}

#hide-input {
    background: transparent;
    border: none;
    outline: none;
    color: transparent;
    position: absolute;
    width: 80%;
    height: 50px;
    font-size: 1px;
    overflow: hidden;
}

.crm-resend-code {
    margin-top: 24px;
    text-align: center;
    color: var(--primary);
    font-size: 20px;
}

.crm-unsend-code {
    color: #999999;
}

.error-msg {
    margin-top: 24px;
}
.error-msg p {
    margin: 0;
    text-align: center;
    color: var(--error);
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: 0px;
    text-align: center;
}
.el-divider__text {
    color: #bdbdbd;
}

.card-system-error {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #fff;
    width: 80%;
    margin: auto;
    padding: 20px 0;
    border-radius: 20px;
}

.card-system-error .el-button--primary {
    background: #fff;
    color: var(--primary);
}

.font1-5rem {
    font-size: 1.5rem;
}

.font1-25rem {
    font-size: 1.25rem;
}
</style>
